export { default as Tooltip } from './Tooltip'
export type { TooltipProps, TooltipBasePlacement, TooltipComputedPlacement } from './Tooltip.types'
